import axios from "axios";
import { TestListActionTypes } from "../constants/TestListActionTypes";

const getTests = (setIsLoading, toast) => {
    return (dispatch)=>{
        setIsLoading(true)
        axios.get("/getSheduledExams")
        .then(res=>{
            console.log(res)
            dispatch({type:TestListActionTypes.GET_TESTS, payload:res.data})
            setIsLoading(false)
        })
        .catch(err=>{
            console.log(err)
            console.log(err.response)
            toast.error("Something Went Wrong!")
            setIsLoading(false)
        })
    }
}


export {
    getTests
}